import { Injectable } from '@angular/core';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor() { }

  returnCurrentFilters(params: any) {

    const formattedParams: any = {
      page: params ? params.page : 1,
      limit: params ? params.limit : EndpointsConstants.requestLimit
    };
    if (params.filters) {
      formattedParams.filters = JSON.stringify(params.filters);
    }

    return formattedParams;
  }

}
